function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32pt",
    height: "32pt",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255,255,255)",
      fillOpacity: 1
    },
    d: "M 7.117188 9.421875 L 16.980469 18.605469 L 26.882812 9.421875 Z M 5.914062 10.542969 L 5.914062 23.414062 L 12.609375 16.71875 Z M 28.085938 10.542969 L 21.390625 16.71875 L 28.085938 23.414062 Z M 13.773438 17.84375 L 7.078125 24.578125 L 27.125 24.578125 L 20.066406 17.84375 L 17.421875 20.289062 C 17.113281 20.566406 16.644531 20.566406 16.339844 20.289062 Z M 13.773438 17.84375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/contact-email.66b4ba34e5fc4e0c4216e904ccd6a3d1.svg";
export { ForwardRef as ReactComponent };